import { AttributeType } from "../components/attributes/AttributeList";
import { strings } from "../localization/LocalizedStrings";
import { IconType } from "../icons";

export const AttributeUtilities = {
  getAttributeTitle: (attributeType: AttributeType) => {
    switch (attributeType) {
      case AttributeType.ARTISTS:
        return strings.attribute_artists_title;
      case AttributeType.STORES:
        return strings.attribute_stores_title;
      case AttributeType.LABELS:
        return strings.attribute_labels_title;
      case AttributeType.ALBUM_FORMATS:
        return strings.attribute_album_formats_title;
      case AttributeType.ALBUM_TYPES:
        return strings.attribute_album_types_title;
      case AttributeType.SLEEVE_GRADES:
        return strings.attribute_sleeve_grades_title;
      case AttributeType.MEDIA_GRADES:
        return strings.attribute_media_grades_title;
      case AttributeType.SELL_VALUES:
        return strings.attribute_sell_values_title;
      case AttributeType.IMPACTS:
        return strings.attribute_impacts_title;
      case AttributeType.EXCHANGE_RATES:
        return strings.attribute_exchange_rates_title;
      case AttributeType.TAGS:
        return strings.tags_title;
      case AttributeType.ORIGIN_COUNTRIES:
        return strings.origin_countries_title;
      case AttributeType.GEAR_ITEMS:
        return strings.gear_items_title;
      case AttributeType.EQUIPMENTS:
        return strings.equipments_title;
    }
  },
  getGoldmineGradePoints: (points: number) => {
    return points <= 10 ? points : strings.mint;
  }
};

export const attributeIconMap: Record<AttributeType, IconType> = {
  [AttributeType.ARTISTS]: IconType.Artist,
  [AttributeType.LABELS]: IconType.MusicCast,
  [AttributeType.ALBUM_FORMATS]: IconType.ControlCamera,
  [AttributeType.ALBUM_TYPES]: IconType.Album,
  [AttributeType.SLEEVE_GRADES]: IconType.CheckBox,
  [AttributeType.MEDIA_GRADES]: IconType.CheckCircle,
  [AttributeType.STORES]: IconType.Store,
  [AttributeType.SELL_VALUES]: IconType.PriceChange,
  [AttributeType.IMPACTS]: IconType.Star,
  [AttributeType.EXCHANGE_RATES]: IconType.CurrencyExchange,
  [AttributeType.TAGS]: IconType.Sell,
  [AttributeType.ORIGIN_COUNTRIES]: IconType.Flag,
  [AttributeType.GEAR_ITEMS]: IconType.AudioVideoReceiver,
  [AttributeType.EQUIPMENTS]: IconType.SpeakerGroup
};
